module.exports = "https://static.zego.com/_next/static/images/CustomerService1-99a6964b4372f55500bed7b7508c9d89.jpg";